/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import InThePress from "./InThePress.container";

export default InThePress;
